import React from "react";

function Leverage() {
  return (
    <div className="leverage-bg mt-5 mb-5">
      <div className="container">
        <div className="row justify-content-center align-items-center ">
          <div className="col-lg-10 col-md-12 col-sm-12 mt-5 mb-5 ">
            <h1 className="Text-heading text-center " data-aos="fade-up">
              Dubai Expert AI Developers
            </h1>
            <p className="text-center text-detail" data-aos="fade-up">
              As a famous AI development firm in Dubai, we provide world-class
              AI services and solutions to our worldwide customer network and
              can meet even the most specialised business requirements.
            </p>
            <div className="text-center" data-aos="fade-up">
              <button className="btn btn-experts p-3">Contact Us</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leverage;
